var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAppleSm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.871,
    height: 17.777,
    viewBox: "0 0 13.871 17.777",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#9ba6ac",
    d: "M41.562,2.7a3.453,3.453,0,0,0,1-2.7,4.508,4.508,0,0,0-2.823,1.282A3.307,3.307,0,0,0,38.718,3.9,3.759,3.759,0,0,0,41.562,2.7Zm2.052,6.847a3.983,3.983,0,0,1,1.839-3.342,3.937,3.937,0,0,0-3.115-1.739c-1.327-.139-2.588.8-3.262.8s-1.709-.786-2.81-.764a4.152,4.152,0,0,0-3.524,2.2c-1.5,2.687-.385,6.667,1.08,8.846.716,1.067,1.569,2.264,2.688,2.22,1.081-.043,1.488-.719,2.792-.719s1.67.719,2.811.7c1.161-.022,1.9-1.087,2.606-2.158a9.812,9.812,0,0,0,1.18-2.5A3.867,3.867,0,0,1,43.614,9.549Z",
    transform: "translate(-32.029 0)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppleSm);
export default __webpack_public_path__ + "static/media/apple-sm.be29187d.svg";
export { ForwardRef as ReactComponent };